import React from 'react';
import {Fade} from 'react-awesome-reveal';
import classes from '../courses.module.css';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';
import useReducedMotion from '../hooks/useReducedMotion';

/**
 * Тёмная полоса-призыв. На странице курса стоит сразу после тематического плана:
 * там пик намерения — человек только что дочитал «ИТОГО 16» и прикинул,
 * во сколько ему обойдётся отсутствие сотрудника два дня.
 */
const CtaStrip = ({titleId, textId, buttonId, onClick, secondaryId, onSecondary, secondaryHref}) => {
    const reduced = useReducedMotion();

    const body = (
        <div className={classes.ctaInner}>
            <div className={classes.ctaTextCol}>
                <h2 className={classes.ctaTitle}><IntlMessage id={titleId}/></h2>
                <p className={classes.ctaText}><IntlMessage id={textId}/></p>
            </div>
            <div className={classes.ctaButtons}>
                <button type="button" className={classes.btnAccent} onClick={onClick}>
                    <IntlMessage id={buttonId}/>
                </button>
                {secondaryId && (secondaryHref
                    ? (
                        <a className={classes.btnGhostLight} href={secondaryHref}>
                            <IntlMessage id={secondaryId}/>
                        </a>
                    )
                    : (
                        <button type="button" className={classes.btnGhostLight} onClick={onSecondary}>
                            <IntlMessage id={secondaryId}/>
                        </button>
                    ))}
            </div>
        </div>
    );

    return (
        <section className={classes.ctaStrip}>
            {reduced ? body : <Fade triggerOnce direction="up" duration={500} style={{width: '100%'}}>{body}</Fade>}
        </section>
    );
};

export default CtaStrip;
